var exports = {
  "K": "xfd349460--05c840--icon",
};

module.exports = exports;
